import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyle = makeStyles((theme) => ({
  buttonAlert: {
    color: theme.palette.primary.contrastText,
    background: theme.palette.primary.main,
    width: '160px',
    height: '30px',
    padding: '5px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '4px',
  },
}));
